import React from "react";

import { LoadingOverlay } from "@mantine/core";

export const RouterLoadingComponent = React.memo<{ bgColor?: string }>(
  function RouterLoadingComponent({ bgColor }) {
    return (
      <LoadingOverlay
        bg={bgColor}
        visible
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 3 }}
      />
    );
  },
);
